"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsumerTrackingServiceV2 = void 0;
class ConsumerTrackingServiceV2 {
    constructor(proxy, defaultId) {
        this.proxy = proxy;
        this.cancelRegisteredImpressions = new Set();
        this.featureAppId = defaultId;
    }
    get featureAppName() {
        return this.savedFeatureAppName;
    }
    set featureAppName(featureAppName) {
        this.savedFeatureAppName = featureAppName;
        this.proxy.setFeatureAppName({ id: this.featureAppId, name: this.featureAppName });
    }
    track(data, arrayBehavior) {
        this.proxy.track({ id: this.featureAppId, name: this.featureAppName }, data, arrayBehavior);
    }
    enableDebugMode(featureAppName, events) {
        this.proxy.enableDebugMode(featureAppName, events);
    }
    trackInternalNavigation(data) {
        this.proxy.trackInternalNavigation({ id: this.featureAppId, name: this.featureAppName }, data);
    }
    updatePageInfo(pageUpdate) {
        this.proxy.updatePageInfo({ id: this.featureAppId, name: this.featureAppName }, pageUpdate);
    }
    registerImpressionTracking(element, dataCallback) {
        const unregister = this.proxy.registerImpressionTracking({ id: this.featureAppId, name: this.featureAppName }, element, dataCallback);
        this.cancelRegisteredImpressions.add(unregister);
        return unregister;
    }
    updateComponent(componentUpdate, arrayBehavior) {
        this.proxy.updateComponent({ id: this.featureAppId, name: this.featureAppName }, componentUpdate, arrayBehavior);
    }
    updateUser(data) {
        this.proxy.updateUser(data);
    }
    evaluateLinkType(targetUrl) {
        return this.proxy.evaluateLinkType(targetUrl);
    }
    getDatalayer() {
        return this.proxy.getDatalayer();
    }
    sanitizeUrl(url) {
        return this.proxy.sanitizeUrl(url);
    }
    asChildOf(rootFeatureAppId, index) {
        this.proxy.asChildOf(rootFeatureAppId, { id: this.featureAppId, name: this.featureAppName }, index);
    }
    unbind() {
        this.cancelRegisteredImpressions.forEach((unregister) => unregister());
        this.cancelRegisteredImpressions.clear();
        this.proxy.removeComponent(this.featureAppId);
    }
}
exports.ConsumerTrackingServiceV2 = ConsumerTrackingServiceV2;
//# sourceMappingURL=consumer.js.map